import { c as _c } from "react/compiler-runtime";
import { MaterialIcon } from "@website/icons/material";
import { InputPropertiesType } from "@website/ui/datepicker/components/input/input.types";
import { MONTH_NAMES } from "@website/ui/datepicker/constanst";
import { numberConvert } from "@website/utils/number-convert";
export const useInput = properties => {
  const $ = _c(37);
  const {
    id,
    fromTitle,
    toTitle,
    value,
    setMode,
    calendarLocale,
    onOpenPopover,
    disabled,
    size: t0,
    noBorder,
    hasDropdownIcon
  } = properties;
  const size = t0 === undefined ? "default" : t0;
  let t1;
  bb0: {
    if (value?.[0]) {
      const month = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[value[0].month - 1];
      let t2;
      if ($[0] !== value[0].day) {
        t2 = numberConvert(value[0].day, {
          numberOnly: true,
          locale: "fa"
        });
        $[0] = value[0].day;
        $[1] = t2;
      } else {
        t2 = $[1];
      }
      const day = t2;
      t1 = `${day} ${month}`;
      break bb0;
    }
    t1 = "";
  }
  const startTextFieldValue = t1;
  let t2;
  bb1: {
    if (value?.[1]) {
      const month_0 = (MONTH_NAMES[calendarLocale] || MONTH_NAMES.gregorian)[value?.[1].month - 1];
      const t3 = value?.[1].day;
      let t4;
      if ($[2] !== t3) {
        t4 = numberConvert(t3, {
          numberOnly: true,
          locale: "fa"
        });
        $[2] = t3;
        $[3] = t4;
      } else {
        t4 = $[3];
      }
      const day_0 = t4;
      t2 = `${day_0} ${month_0}`;
      break bb1;
    }
    t2 = "";
  }
  const endTextFieldValue = t2;
  let t3;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = {
      tabIndex: 0
    };
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const t4 = value?.[0] ? fromTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u0634\u0631\u0648\u0639" : "";
  const t5 = value?.[0] ? "" : fromTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u0634\u0631\u0648\u0639";
  let t6;
  if ($[5] !== hasDropdownIcon) {
    t6 = hasDropdownIcon && <MaterialIcon name="arrow_drop_down" variant="fill" />;
    $[5] = hasDropdownIcon;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== disabled || $[8] !== noBorder || $[9] !== onOpenPopover || $[10] !== size || $[11] !== startTextFieldValue || $[12] !== t4 || $[13] !== t5 || $[14] !== t6) {
    t7 = {
      "data-testid": "date_picker_start_input",
      label: t4,
      placeholder: t5,
      EndIcon: t6,
      readOnly: true,
      value: startTextFieldValue,
      onClick: onOpenPopover,
      fullWidth: true,
      disabled,
      size,
      noBorder
    };
    $[7] = disabled;
    $[8] = noBorder;
    $[9] = onOpenPopover;
    $[10] = size;
    $[11] = startTextFieldValue;
    $[12] = t4;
    $[13] = t5;
    $[14] = t6;
    $[15] = t7;
  } else {
    t7 = $[15];
  }
  const t8 = value?.[1] ? toTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u067E\u0627\u06CC\u0627\u0646" : "";
  const t9 = value?.[1] ? "" : toTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u067E\u0627\u06CC\u0627\u0646";
  let t10;
  if ($[16] !== hasDropdownIcon) {
    t10 = hasDropdownIcon && <MaterialIcon name="arrow_drop_down" variant="fill" />;
    $[16] = hasDropdownIcon;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== disabled || $[19] !== endTextFieldValue || $[20] !== id || $[21] !== noBorder || $[22] !== onOpenPopover || $[23] !== size || $[24] !== t10 || $[25] !== t8 || $[26] !== t9) {
    t11 = {
      id,
      "data-testid": "date_picker_end_input",
      label: t8,
      placeholder: t9,
      readOnly: true,
      value: endTextFieldValue,
      onClick: onOpenPopover,
      fullWidth: true,
      EndIcon: t10,
      disabled,
      size,
      noBorder
    };
    $[18] = disabled;
    $[19] = endTextFieldValue;
    $[20] = id;
    $[21] = noBorder;
    $[22] = onOpenPopover;
    $[23] = size;
    $[24] = t10;
    $[25] = t8;
    $[26] = t9;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] !== setMode) {
    t12 = setMode?.bind(null, "start-end");
    $[28] = setMode;
    $[29] = t12;
  } else {
    t12 = $[29];
  }
  let t13;
  if ($[30] !== t12) {
    t13 = {
      role: "button",
      onClick: t12
    };
    $[30] = t12;
    $[31] = t13;
  } else {
    t13 = $[31];
  }
  const t14 = toTitle ?? "\u062A\u0627\u0631\u06CC\u062E \u067E\u0627\u06CC\u0627\u0646";
  let t15;
  if ($[32] !== t11 || $[33] !== t13 || $[34] !== t14 || $[35] !== t7) {
    t15 = {
      rootProps: t3,
      startTextFieldProperties: t7,
      endTextFieldProperties: t11,
      endEnableButtonProperties: t13,
      endEnableButtonText: t14
    };
    $[32] = t11;
    $[33] = t13;
    $[34] = t14;
    $[35] = t7;
    $[36] = t15;
  } else {
    t15 = $[36];
  }
  return t15;
};